module.exports = __webpack_public_path__ + "static/media/team.53c39bf2.png";